export default __webpack_public_path__ + "static/media/Avatar-27.875a31a9.svg";